<template>
  <div class="relative inline-flex">
    <svg
      class="w-2 h-2 absolute top-0 right-0 m-4 pointer-events-none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 412 232"
    >
      <path
        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
        fill="#648299"
        fill-rule="nonzero"
      />
    </svg>
    <select
      class="border-2 border-gray-400 rounded-lg
        text-gray-600 pl-5 pr-10 bg-white
        hover:border-gray-400
          focus:outline-none
          appearance-none"
      :style="{
        '--focus-border-color': global.primaryColor
      }"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      @mousedown="handleFirstClick()"
    >
      <option
        style="display:none;"
        selected
      >
        {{ defaultSelectorText }}
      </option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :selected="option===defaultSelectorValue"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Select',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    defaultSelectorText: {
      type: String,
      required: true
    },
    options: {
      type: Array as PropType<Array<string>>,
      required: true
    },
    defaultSelectorValue: {
      type: String,
      default: undefined,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ])
  },
  methods:{
    handleFirstClick(){
      if(!this.defaultSelectorValue)
        return;
      if(this.modelValue == this.defaultSelectorText){
        this.$emit('update:modelValue', this.defaultSelectorValue);
      }
    }
  }
});
</script>

<style>
select:focus {
  border-color: var(--focus-border-color) !important;
}
</style>
